<div class="container" *ngIf="userRole === 'Administrator'">
  <app-template [title]="'Admin Dashboard'" [ngSwitch]="mode">
    <div>
      <div class="row w-row">
        <div class="basic-column w-col w-col-3" [routerLink]="['/patient']">
          <div class="tag-wrapper">
            <div class="number-card number-card-content1">
              <!-- <h2 class="number-card-number">{{ emplyees?.length }}</h2> -->
              <h2 class="number-card-number">
                {{ numberWithCommas(dashboardData["PATIENT_COUNT"]) }}
              </h2>
              <div class="divider"></div>
              <div class="number-card-dollars">Total Number of Patients</div>
            </div>
          </div>
        </div>
        <div class="basic-column w-col w-col-3" [routerLink]="['/patient']">
          <div class="tag-wrapper">
            <div class="number-card number-card-content2">
              <!-- <h2 class="number-card-number">{{ emplyees?.length }}</h2> -->
              <h2 class="number-card-number">
                {{ numberWithCommas(dashboardData["LABORATORY"]) }}
              </h2>
              <div class="divider"></div>
              <div class="number-card-dollars">Total No of Lab Patients</div>
            </div>
          </div>
        </div>
        <div class="basic-column w-col w-col-3" [routerLink]="['/xray']">
          <div class="tag-wrapper">
            <div class="number-card number-card-content3">
              <h2 class="number-card-number">
                {{ numberWithCommas(dashboardData["ULTRASOUND"]) }}
              </h2>
              <div class="divider"></div>
              <div class="number-card-dollars">
                Total No of Ultrasound Patients
              </div>
            </div>
          </div>
        </div>
        <div class="basic-column w-col w-col-3" [routerLink]="['/radiology']">
          <div class="tag-wrapper">
            <div class="number-card number-card-content4">
              <h2 class="number-card-number">
                {{ numberWithCommas(dashboardData["RADIOLOGY"]) }}
              </h2>
              <div class="divider"></div>
              <div class="number-card-dollars">
                Total No of Radiology Patients
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="divider"></div>

      <!-- <div class="section2">
        <div class="section2-div">
          <h2>ACCOUNTS</h2>
          <div class="account-div">
            <span>
              <h3>Cummulative Amount</h3>
              <p>56,869,272</p>
            </span>
            <span>
              <h3>Refunded Amount</h3>
              <p>6,389,139</p>
            </span>
            <span>
              <h3>Discounted Amount</h3>
              <p>869,272</p>
            </span>
          </div>
        </div>
        <div class="section2-div">
          <h2>COLLECTION</h2>
        </div>
      </div> -->
    </div>
  </app-template>
  <p style="text-align: center; margin-top: 10px">
    Version {{ appVersionNumber?.version }}
  </p>
</div>

<div class="container" *ngIf="userRole !== 'Administrator'">
  <div>
    <app-template [title]="'User Profile'" [ngSwitch]="mode">
      <div class="all" *ngSwitchCase="'all'">
        <table>
          <tr>
            <td>
              <div class="lable">User Name :</div>
            </td>
            <td>
              <div class="name">{{ profile?.username }}</div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="lable">Name :</div>
            </td>
            <td>
              <div class="name">{{ profile?.first_name }}</div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="lable">Qualification :</div>
            </td>
            <td>
              <div class="name">{{ profile?.qualification }}</div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="lable">Designation :</div>
            </td>
            <td>
              <div class="name">{{ profile?.designation }}</div>
            </td>
          </tr>
          <tr></tr>
          <tr class="sig">
            <td>
              <button
                type="button"
                class="button"
                mat-raised-button
                color="primary"
                (click)="addSign()"
                style="
                  width: 100px;
                  margin-left: -0px;
                  margin-top: 10px;
                  background-color: #0c5a96;
                "
              >
                Change
              </button>
            </td>
            <td>
              <div class="img">
                <img [src]="signatureImage" *ngIf="signatureImage" />
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div *ngSwitchCase="'sign1'">
        <button
          type="button"
          class="button"
          mat-raised-button
          color="primary"
          (click)="back()"
          style="
            width: 100px;
            margin-left: -0px;
            margin-top: 10px;
            background-color: #0c5a96;
          "
        >
          Back
        </button>
        <div class="sign">
          <ng-signature-pad
            doneButtonText="Add"
            format="base64"
            doneButtonClass="btn btn-primary"
            clearButtonClass="btn btn-primary"
            (done)="showImage1($event)"
          >
          </ng-signature-pad>
        </div>
      </div>
    </app-template>
    <p style="text-align: center; margin-top: 10px">
      Version {{ appVersionNumber?.version }}
    </p>
  </div>
</div>
